/*document.addEventListener("DOMContentLoaded", () => {
  const elements = document.querySelectorAll(".shopify-section");

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("visible");
        observer.unobserve(entry.target); // 👈 deja de observar luego de animar
      }
    });
  }, { threshold: 0.2, rootMargin: "50px" });

  elements.forEach(el => observer.observe(el));
});*/

document.addEventListener("DOMContentLoaded", () => {
  const elements = document.querySelectorAll(".shopify-section:not(.shopify-section-group-footer-group)");

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.intersectionRatio > 0.25) {
        // entra al viewport al menos 25%
        entry.target.classList.add("visible");
      } else if (entry.intersectionRatio < 0.05) {
        // solo quita visible cuando casi salió del todo
        entry.target.classList.remove("visible");
      }
    });
  }, { threshold: [0, 0.05, 0.25, 0.5], rootMargin: "0px 0px -5% 0px" });

  elements.forEach(el => observer.observe(el));
});